import { Reveal } from "./Reveal";

const ITEMS = [
  { big: "15+", small: "Years of Clinical Experience" },
  { big: "16,000+", small: "Pediatric Cases Consulted" },
  { big: "Personalized", small: "Child-Centric Approach" },
  { big: "USA", small: "Limited In-Person Consultations" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="bg-[#FAF7F2] border-y border-[#E5D3AD]/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {ITEMS.map((it, i) => (
          <Reveal key={it.big} delay={i * 0.08} className="text-center lg:text-left lg:border-l lg:border-[#E5D3AD]/60 lg:pl-8 first:border-0 first:pl-0">
            <p className="font-serif text-3xl lg:text-4xl text-[#1B3B2B]">{it.big}</p>
            <p className="mt-1.5 text-xs lg:text-sm text-[#5C6E62] leading-snug">{it.small}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
